import _ from 'lodash'
import checkit from 'lodash-checkit'
import axios from 'axios'
import qs from 'query-string'
import numeral from 'numeral'
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
import xlsx from 'xlsx'
import FileSaver from 'file-saver'
import flat from 'flat'
import { API_URL } from './constants'

momentDurationFormatSetup(moment)

export const ccy = (number, format = '0,0.00', zero = '', symbol = '€') =>
  number !== 0 ? `${symbol}${numeral(Number(number)).format(format)}` : zero

export const calculateFlag = (
  date,
  dateRef = new Date(),
  period = 'months',
  abs = true
) => {
  if (!date || !dateRef) return 0
  const difference = moment(dateRef).diff(moment(date), period)
  return date && dateRef ? (abs ? Math.abs(difference) : difference) : null
}

export const calculateFrequencyDate = (date, period) => {
  if (!date) return null
  return moment(date).add(6 * (period || 0), 'M')
}

export const calculateAge = (dob, period = 'months') => {
  if (!dob) return null

  const diffDays = moment().diff(moment(dob), 'days')

  return formatYMD(diffDays, period)
  // moment().diff(moment(dob), 'years')
  // return dob ? moment().diff(moment(dob)) : null
}

export const calculatePeriod = (
  date,
  dateRef,
  period = 'months',
  abs = true
) => {
  let diffDays
  if (abs) {
    diffDays =
      moment(dateRef).diff(moment(date), 'days') < 0
        ? moment(date).diff(moment(dateRef), 'days')
        : moment(dateRef).diff(moment(date), 'days')
  } else {
    diffDays = moment(dateRef).diff(moment(date), 'days')
  }

  return formatYMD(diffDays, period)

  // const difference = moment(dateRef).diff(moment(date), period)
  // return date && dateRef ? (abs ? Math.abs(difference) : difference) : null
}

export const formatYMD = (diffDays, period) => {
  let date = moment.duration(diffDays, 'days').format()
  date = date.split(' ').join('')
  date = date.split(',').join(' ')
  date = date.split('ea').join('')
  date = date.split('on').join('')

  if (period === 'months') {
    date = date
      .split(' ')
      .splice(0, 2)
      .join(' ')
  }

  if (date.search('0y') > -1 && date[0] === 0) {
    date = date
      .split(' ')
      .slice(0)
      .join(' ')
  }

  return date
}

// export const updateUrl = (location, toUpdate) => {
//   const urlQuery = flat.unflatten(qs.parse(location.search))
//   return qs.stringify(flat.flatten(Object.assign({}, urlQuery, toUpdate)))
// }

// export const getUrlObject = location => {
//   let urlObjects = flat.unflatten(qs.parse(location.search))
//   if (!urlObjects.filters) Object.assign(urlObjects, { filters: [] })
//   if (!urlObjects.sorting) Object.assign(urlObjects, { sorting: [] })
//   return urlObjects
// }

export const ccyFormat = (number, format = '0,0.00', zero = 0) =>
  number && number !== 0 ? `${numeral(Number(number)).format(format)}` : zero

export const getInitials = user =>
  user.includes('.')
    ? `${user.substr(0, 1)}${user.substr(
        user.indexOf('.') + 1,
        1
      )}`.toUpperCase()
    : `${user.substr(0, 2)}`.toUpperCase()

export const getName = user =>
  user.includes('.')
    ? toProperCase(
        `${user.substr(0, user.indexOf('.'))} ${user.substr(
          user.indexOf('.') + 1
        )}`
      )
    : `${user}`

const toProperCase = (text, opt_lowerCaseTheRest = true) => {
  return (opt_lowerCaseTheRest ? text.toLowerCase() : text).replace(
    /(^|[\s\xA0])[^\s\xA0]/g,
    function(s) {
      return s.toUpperCase()
    }
  )
}

export const validateLength = (stringToTest, length) =>
  /^.{1,10}$/.test(stringToTest)

export const keepInLength = (stringToTest, length) => {
  if (stringToTest) {
    const str = String(stringToTest)
    return str.length > length ? str.substr(0, length) : str
  }
  return stringToTest
}

export const isEmail = stringToTest =>
  // eslint-disable-next-line
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    stringToTest
  )

export const isPhone = stringToTest => /^0+(\d{8}|\d{9})$/.test(stringToTest)

export const isFax = stringToTest => /^0+(\d{8}|\d{9})$/.test(stringToTest)

const removeAlphaChars = v => v.replace(/[^\d]/g, '')
const onlyDecimal = value => {
  value = value.replace(/[^0-9.]/g, '') // Remove all chars except numbers and .

  // Create an array with sections split by .
  const sections = value.split('.')
  // Remove any leading 0s apart from single 0

  if (sections[0] !== '0' && sections[0] !== '00') {
    sections[0] = sections[0].replace(/^0+/, '')
  } else {
    sections[0] = '0'
  }

  // If numbers exist after first .
  if (sections[1]) {
    // Join first two sections and truncate end section to length 2
    return sections[0] + '.' + sections[1].slice(0, 2)
    // If original value had a decimal place at the end, add it back
  } else if (value.indexOf('.') !== -1) {
    return sections[0] + '.'
    // Otherwise, return only section
  } else {
    return sections[0]
  }
}

const keepInRange = (v, min = -Infinity, max = Infinity) => {
  if (v > max) return max
  if (v < min) return min
  return v
}

export const normalizePrice = (v, min = 0) => {
  return keepInRange(onlyDecimal(v), 0)
}

export const normalizeInRange = (v, min, max) => {
  return keepInRange(removeAlphaChars(v), min, max)
}

export const saveToExcel = (data, sheetName, fileName) => {
  fileName = sheetName && sheetName

  function s2ab(s) {
    var buf = new ArrayBuffer(s.length)
    var view = new Uint8Array(buf)
    for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
    return buf
  }
  const file = xlsx.write(
    {
      SheetNames: [sheetName],
      Sheets: { [sheetName]: xlsx.utils.json_to_sheet(data) }
    },
    { bookType: 'xlsx', bookSST: false, type: 'binary' }
  )

  FileSaver.saveAs(
    new Blob([s2ab(file)], { type: 'application/octet-stream' }),
    `${fileName}.xlsx`
  )
}

export const remapArray = (array, fieldMappings) =>
  array.map(({ id, ...rest }) =>
    _.mapKeys(flat(rest), (value, key) => fieldMappings[key])
  )

export const unremapArray = (array, fieldMappings) =>
  array.map(elem =>
    flat.unflatten(
      _.mapKeys(
        elem,
        (value, key) => _.findKey(fieldMappings, value => value === key) || null
      )
    )
  )

export const uploadDataFromExcel = async (
  file,
  existingData,
  fieldMappings,
  path
) => {
  const data = await retrieveDataFromExcel(file)
  const dataToUpload = compareData(
    unremapArray(data, fieldMappings),
    existingData
  )

  dataToUpload.toAdd.forEach(
    async e =>
      await axios.post(`${API_URL}${path}`, e, {
        headers: { authorization: auth(true) }
      })
  )
  dataToUpload.toUpdate.forEach(
    async e =>
      await axios.put(`${API_URL}${path}${e.id}`, e, {
        headers: { authorization: auth(true) }
      })
  )
  return dataToUpload
}

const retrieveDataFromExcel = file =>
  new Promise(resolve => {
    const reader = new FileReader()

    reader.onload = e => {
      const fileRead = xlsx.read(e.target.result, { type: 'binary' })
      const data = xlsx.utils.sheet_to_json(
        fileRead.Sheets[fileRead.SheetNames[0]]
      )
      resolve(data)
    }
    reader.readAsBinaryString(file[0])
  })

const compareData = (newData, existingData) => {
  let toAdd = [],
    toUpdate = []
  newData.forEach(d => {
    const existingItem = _.find(existingData, { number: d.number })
    if (existingItem) {
      if (!_.isEqual({ ...existingItem, ...d }, existingItem))
        toUpdate.push({ ...existingItem, ...d })
    } else toAdd.push(d)
  })
  return { toAdd, toUpdate }
}

export const downloadToExcel = (data, fileName) => {
  if (!data) return
  if (data.length === 1 && !fileName) fileName = `${data[0].name}.xlsx`
  if (!fileName) fileName = 'Export.xlsx'
  const sheetNames = data.map(d => d.name)
  const sheetData = data.map(d => xlsx.utils.json_to_sheet(d.data))

  const file = xlsx.write(
    {
      SheetNames: sheetNames,
      Sheets: _.zipObject(sheetNames, sheetData)
    },
    { bookType: 'xlsx', bookSST: false, type: 'binary' }
  )

  FileSaver.saveAs(
    new Blob([s2ab(file)], { type: 'application/octet-stream' }),
    `${cleanFileName(fileName)}.xlsx`
  )
}

function s2ab(s) {
  var buf = new ArrayBuffer(s.length)
  var view = new Uint8Array(buf)
  for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
  return buf
}

export const cleanFileName = name => {
  name = name.replace(/\s+/gi, '-') // Replace white space with dash
  // eslint-disable-next-line no-useless-escape
  return name.replace(/[^a-zA-Z0-9\-]/gi, '') // Strip any special charactere
}

export const auth = (getToken = false) => {
  return getToken
    ? sessionStorage.getItem('apiKey')
    : !!sessionStorage.getItem('apiKey')
}

export const authUser = async (email, password, getToken = false) => {
  const { data: { apiKey } } = await axios.post(`${API_URL}/login`, {
    email,
    password
  })
  // const { data: { apiKey } } = await axios.get(`${API_URL}/login/1`)
  sessionStorage.setItem('apiKey', apiKey || false)
  return !!apiKey
}

export const getUserId = () => sessionStorage.getItem('user')

export const getUserRole = async (user = harmonizeUserName(getUserId())) => {
  const { data: users } = await axios.get(`${API_URL}/users/`, {
    headers: { authorization: auth(true) }
  })
  const userObject = _.find(harmonizeUserName(users), { email: user })
  return userObject ? userObject.role : undefined
}

export const getUserProfile = async (user = getUserId()) => {
  const { data } = await axios.get(`${API_URL}/users/${user}`, {
    headers: { authorization: auth(true) }
  })

  return data
}

export const getUsersWithCentre = async () => {
  const queries = [
    axios.get(`${API_URL}/users/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/roles/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/centres/`, {
      headers: { authorization: auth(true) }
    })
  ]

  const data = await Promise.all(queries)
  const users = data[0].data
  const roles = data[1].data
  const centres = data[2].data

  const usersWithCentre = users.map(u => {
    const userRoles = _.find(roles, ['registerId', u.id])
    if (!(userRoles && userRoles.centre)) return u
    const userCentre = _.find(centres, ['id', userRoles.centre.centreName])
    return {
      ...u,
      centreId: userCentre.id
      // centreDetails: {
      //   id: userCentre.id,
      //   name: userCentre.name
      // }
    }
  })

  return { data: usersWithCentre }
}

export const setUserProfileLocal = async (userId = getUserId(), users) => {
  const profile = _.omit(_.find(users, ['email', userId]), ['password'])
  sessionStorage.setItem('profile', qs.stringify(profile))
}

export const getUserProfileLocal = () => {
  return qs.parse(sessionStorage.getItem('profile'))
}

export const getUserByEmail = async (user = getUserId()) => {
  const { data } = await axios.get(
    `${API_URL}/users/?${qs.stringify({ email: user })}`,
    {
      headers: { authorization: auth(true) }
    }
  )

  return _.isArray(data) ? data[0] : data
}

export const harmonizeUserName = users => {
  if (checkit.isArray(users))
    return users.map(({ email, ...rest }) => ({
      ...rest,
      email: email.toLowerCase()
    }))
  return users.toLowerCase()
}

export const getLoginFromMail = email => {
  const userId = email || `${email}@`
  return userId.split('@')[0]
}



// WEBPACK FOOTER //
// ./src/core/helpers.js